<template>
  <open-banking-description-step class="obk-description-certificate-note-step" :step-number="stepNumber">
    <template v-slot:text>
      אם קופצת הודעה לגבי Certificate - אפשר
      <span class="bold">ללחוץ על ביטול ולהמשיך.</span>
    </template>
  </open-banking-description-step>
</template>

<script>
import OpenBankingDescriptionStep from '@/base-components/onboarding/openBanking/OpenBankingDescriptionStep';

export default {
  name: 'ObkDescriptionCertificatedNoteStep',
  components: {
    OpenBankingDescriptionStep,
  },
  props: {
    stepNumber: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>

.obk-description-certificate-note-step {
  .bold {
    font-weight: bold;
  }
}

</style>
